function BlankScreen() {
  return null;
}

export default BlankScreen;
